import { ModalEntry } from '@superbet-group/web.lib.vue-utilities';

import { logger } from '@app/logger';

export function registerModals(modalConfig: ModalEntry[]): void {
    modalConfig.forEach((modalEntry) => {
        if (modalsMap[modalEntry.code]) {
            logger.warn(`Modal with code ${modalEntry.code} already exists`);
        }

        modalsMap[modalEntry.code] = Object.freeze(modalEntry); // Extra safety for code ignoring TS readonly guard
    });
}

export function getModalEntry(code: string): Readonly<ModalEntry> {
    if (modalsMap[code] === undefined) {
        throw new Error(`Modal with code ${code} doesn't exist`);
    }

    return modalsMap[code];
}

export function clearModals(): void {
    if (process.env.NODE_ENV !== 'test') {
        throw new Error('For use in tests only');
    }
    Object.keys(modalsMap).forEach((key) => delete modalsMap[key]);
}

const modalsMap: Record<string, ModalEntry> = {};
